<template>
  <main class="not-found-page" aria-labelledby="not-found-heading">
    <!-- Per-page SEO: unique title + meta description (Requirement 10.1). -->
    <SeoHead :seo="seo" />

    <section class="not-found">
      <v-container>
        <div class="not-found__inner">
          <p class="not-found__code">404</p>
          <h1 id="not-found-heading" class="not-found__heading">
            This page couldn’t be found
          </h1>
          <p class="not-found__body">
            The page you’re looking for may have moved, or the address might be
            slightly off. Let’s get you back on track.
          </p>
          <CtaButton to="/" label="Back to home" />
        </div>
      </v-container>
    </section>
  </main>
</template>

<script>
// NotFoundPage — branded 404 page for unmatched routes (Requirement 13.4).
//
// Rendered by the catch-all route (`/:pathMatch(.*)*`) in the router. Applies
// the ThinkSpatial brand styling, sets per-page SEO via SeoHead, and offers a
// CtaButton linking back to the Home page so visitors can recover easily.
//
// Uses the Options API to match the project's `plugin:vue/essential` ESLint
// preset.
import SeoHead from '@/components/SeoHead.vue'
import CtaButton from '@/components/CtaButton.vue'

export default {
  name: 'NotFoundPage',
  components: {
    SeoHead,
    CtaButton,
  },
  data () {
    return {
      // Inline PageSeo model — the 404 page has no editorial content module.
      seo: {
        title: 'Page not found — ThinkSpatial',
        description:
          'The page you requested could not be found. Return to the ThinkSpatial home page to continue browsing our surveying, GIS, UAV, and spatial software services.',
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.not-found {
  padding: 120px 0;
}

.not-found__inner {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
}

.not-found__code {
  font-size: 6rem;
  font-weight: 800;
  line-height: 1;
  color: #e7511e;
  margin-bottom: 16px;
}

.not-found__heading {
  font-size: 2.25rem;
  font-weight: 800;
  color: #41281b;
  margin-bottom: 16px;
}

.not-found__body {
  font-size: 1.1rem;
  color: #4a4a4a;
  line-height: 1.7;
  margin-bottom: 32px;
}

@media (max-width: 600px) {
  .not-found {
    padding: 72px 0;
  }

  .not-found__code {
    font-size: 4.5rem;
  }

  .not-found__heading {
    font-size: 1.75rem;
  }
}
</style>
